<template>
  <span class="section-menu" v-click-outside="closeMenu">
    <div class="action" v-on:click="emitEditRiseupGoalPopup" v-on:focusout="closeMenu">
      <img class="edit" :src="require('@/assets/pencil.svg')">
      <span>עריכת סכום</span>
    </div>
  </span>
</template>

<script>
import Segment from '../../../../../../../../../../Segment';
import ModalBus from '../../../../../../../../../../event-bus/modal-bus';
import ClickOutside from '../../../../../../../../../../directives/click-outside';
import EditRiseupGoalAmount from './EditRiseupGoalAmount.vue';

export default {
  name: 'RiseupGoalSectionMenu',
  directives: {
    ClickOutside,
  },
  props: {
    closeMenu: {
      type: Function,
      required: true,
    },
  },
  methods: {
    emitEditRiseupGoalPopup() {
      Segment.trackUserInteraction('SectionMenu_EditRiseupGoalClicked');
      ModalBus.$emit('open', {
        component: EditRiseupGoalAmount,
        props: {},
      });
    },
  },
};
</script>


<style lang="scss" scoped>
  @import '../../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .section-menu {
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 13px;
    top: 12px;
    border-radius: 1px;
    background-color: $riseup_white;
    box-shadow: 2px 2px 8px 0 $riseup_gray_0;

    .action {
      display: flex;
      align-items: center;
      font-family: SimplerPro;
      font-size: 14px;
      padding: 0 8px;
      height: 30px;
      width: 100%;
      cursor: pointer;

      img {
        height: 10px;
        padding-left: 8px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/cashflow-edit/edit-riseup-goal/RiseupGoalSectionMenu.vue